import { render, staticRenderFns } from "./discussion_actions.vue?vue&type=template&id=d02ea400&vue3"
import script from "./discussion_actions.vue?vue&type=script&lang=js&vue3"
export * from "./discussion_actions.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports